import { Component } from '@angular/core';

@Component({
  selector: 'app-components-navigation-partner',
  templateUrl: './partner.component.html'
})
export class PartnerComponent {
}
